import { baseUrl, handleResponse, handleError, PutOptions } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/OptionAgreement";

export function createEmpOption(empOption) {
    return fetch(`${apiUrl}/Create`, PutOptions(empOption)).then(handleResponse).catch(handleError);
}